import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvironmentToken } from '../../../app.config';
import {
  OpeningHourType,
  StoreOpeningHourTypePayload,
  UpdateOpeningHourTypePayload,
} from '../../models/catalog/opening-hour-type.model';

@Injectable({ providedIn: 'root' })
export class OpeningHourTypeService {
  #http = inject(HttpClient);
  #apiUrl = inject(EnvironmentToken).apiUrl;

  #items = new BehaviorSubject<OpeningHourType[]>([]);
  public items$ = this.#items.asObservable();
  public items = toSignal(this.items$, { initialValue: [] });

  getAll() {
    this.#http
      .get<{ data: OpeningHourType[] }>(
        `${this.#apiUrl}/api/admin/catalog/opening-hour-types`,
      )
      .subscribe({
        next: (response) => this.#items.next(response.data ?? []),
        error: (e) => console.log(e),
      });
  }

  getById(id: number): Observable<{ data: OpeningHourType }> {
    return this.#http.get<{ data: OpeningHourType }>(
      `${this.#apiUrl}/api/admin/catalog/opening-hour-types/${id}`,
    );
  }

  create(
    payload: StoreOpeningHourTypePayload,
  ): Observable<{ data: OpeningHourType }> {
    return this.#http.post<{ data: OpeningHourType }>(
      `${this.#apiUrl}/api/admin/catalog/opening-hour-types`,
      payload,
    );
  }

  update(
    id: number,
    payload: UpdateOpeningHourTypePayload,
  ): Observable<{ data: OpeningHourType }> {
    return this.#http.patch<{ data: OpeningHourType }>(
      `${this.#apiUrl}/api/admin/catalog/opening-hour-types/${id}`,
      payload,
    );
  }

  delete(id: number): Observable<unknown> {
    return this.#http.delete(
      `${this.#apiUrl}/api/admin/catalog/opening-hour-types/${id}`,
    );
  }
}
